var render, staticRenderFns
import script from "./mountComponent.vue?vue&type=script&lang=js&"
export * from "./mountComponent.vue?vue&type=script&lang=js&"
import style0 from "./mountComponent.vue?vue&type=style&index=0&id=710bce7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bce7b",
  null
  
)

export default component.exports